import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { submitContact } from '../api/contact.api';

const ContactUsPage: React.FC = () => {
  const [formState, setFormState] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (field: string, value: string) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!formState.fullName || !formState.email || !formState.subject || !formState.message) {
      return;
    }

    setLoading(true);
    try {
      await submitContact({
        full_name: formState.fullName,
        email: formState.email,
        phone: formState.phone || undefined,
        subject: formState.subject,
        message: formState.message,
      });
      setSubmitted(true);
      setFormState({ fullName: '', email: '', phone: '', subject: '', message: '' });
    } catch (err) {
      // Silent fail for prototype.
    } finally {
      setLoading(false);
    }
  };

  return (
    <main>
      <header className="py-5" style={{ backgroundColor: '#000000' }}>
        <div className="container">
          <div className="mb-3">
            <Link to="/" className="btn btn-outline-secondary btn-sm">
              <i className="bi bi-arrow-left me-1"></i>
              Back to Home
            </Link>
          </div>
          <div className="text-center">
            <h1 className="display-6 fw-bold text-white">Contact Us</h1>
            <p className="text-muted mt-3" style={{ color: 'rgba(255, 255, 255, 0.8)' }}>
              Have a question, suggestion, or need help? Get in touch with our team.
            </p>
          </div>
        </div>
      </header>

      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="card card-surface shadow-sm">
                <div className="card-body p-4">
                  <h2 className="h5 mb-3">Send a Message</h2>
                  {submitted && (
                    <div className="alert alert-success">
                      Thanks for reaching out. Our team will respond soon.
                    </div>
                  )}
                  <form onSubmit={handleSubmit} className="d-grid gap-3">
                    <div>
                      <label className="form-label">Full Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formState.fullName}
                        onChange={(event) => handleChange('fullName', event.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label className="form-label">Email Address <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        className="form-control"
                        value={formState.email}
                        onChange={(event) => handleChange('email', event.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={formState.phone}
                        onChange={(event) => handleChange('phone', event.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label">Subject <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        value={formState.subject}
                        onChange={(event) => handleChange('subject', event.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label className="form-label">Message <span className="text-danger">*</span></label>
                      <textarea
                        className="form-control"
                        rows={5}
                        value={formState.message}
                        onChange={(event) => handleChange('message', event.target.value)}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-arena" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactUsPage;
